import { Link2, Trash2 } from 'lucide-react';

interface LinksListProps {
  links: string[];
  linkInput: string;
  linkError: string;
  maxReached: boolean;
  maxItems: number;
  onLinkInputChange: (value: string) => void;
  onAddLink: () => void;
  onDeleteLink: (url: string) => void;
  readOnly?: boolean;
}

export const LinksList = ({
  links,
  linkInput,
  linkError,
  maxReached,
  maxItems,
  onLinkInputChange,
  onAddLink,
  onDeleteLink,
  readOnly = false,
}: LinksListProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <div className="flex gap-2">
          <input
            type="url"
            value={linkInput}
            onChange={e => onLinkInputChange(e.target.value)}
            placeholder="Masukkan URL dokumen (misalnya: https://example.com/doc.pdf)"
            className="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
            disabled={readOnly || maxReached}
          />
          {!readOnly && (
            <button
              type="button"
              onClick={onAddLink}
              disabled={!linkInput.trim() || maxReached}
              className="px-4 py-2 bg-blue-600 text-white w-fit rounded-xl hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Tambahkan Tautan
            </button>
          )}
        </div>
        {linkError && <p className="text-xs text-red-600">{linkError}</p>}
        {maxReached && <p className="text-xs text-red-600">Jumlah tautan telah mencapai batas maksimum: {maxItems}</p>}
      </div>

      {links.length === 0 ? (
        <div className="text-center py-8 text-gray-500 dark:text-gray-400">Belum ada tautan yang ditambahkan</div>
      ) : (
        <div className="space-y-2 max-h-[50vh] overflow-y-auto">
          {links.map((url, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 border border-transparent dark:border-gray-700 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <Link2 className="w-5 h-5 text-blue-600 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-blue-600 hover:underline truncate block"
                  >
                    {url}
                  </a>
                </div>
              </div>
              {!readOnly && (
                <button
                  type="button"
                  onClick={() => onDeleteLink(url)}
                  className="text-red-600 hover:text-red-800 transition-colors flex-shrink-0 ml-2"
                  title="Delete"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
